const namespace = {
  title: "Quartiers similaires",
  title_32: "Codes postaux similaires",
  title_37: "Comtés similaires",
  description:
    "Découvrez des lieux similaires à celui-ci et comparez-les en termes de caractéristiques et services de proximité.",
  descriptionWithNeighborhood:
    "Découvrez des lieux similaires à {{neighborhoodName}} et comparez-les en termes de caractéristiques et services de proximité.",
  noData:
    "Les quartiers similaires ne sont pas disponibles pour cet emplacement.",
  tags: {
    negative: "Moins abordable",
    neutral: "Comparable",
    positive: "Plus abordable",
  },
  pagination: {
    previous: "Afficher moins",
    next: "Afficher plus",
  },
} as const;

export default namespace;
